import {
    Paper, TextField, Checkbox, InputAdornment, IconButton,
    FormControl, InputLabel, Select, MenuItem, ListItemText, Chip,
} from "@mui/material";
import {Search, Clear} from "@mui/icons-material";

// Keys match the backend's `risk_tier` field (customer-health.db.js), not the
// display label - the dropdown shows the label, the filter compares the key.
export const RISK_TIER_FILTER_OPTIONS = [
    {value: 'at_risk_of_losing', label: 'At Risk'},
    {value: 'warning_signs', label: 'Warning'},
    {value: 'watch', label: 'Watch'},
    {value: 'healthy', label: 'Healthy'},
    {value: 'lost', label: 'Stopped Buying'},
    {value: 'insufficient_data', label: 'Insufficient Data'},
];
export const ALL_RISK_TIER_VALUES = RISK_TIER_FILTER_OPTIONS.map((o) => o.value);
const RISK_TIER_LABEL_BY_VALUE = Object.fromEntries(RISK_TIER_FILTER_OPTIONS.map((o) => [o.value, o.label]));

export const CustomerHealthFilterBar = ({
    searchText, onSearchTextChange,
    riskTiers, onRiskTiersChange,
    buyingLessOnly, onClearBuyingLessOnly,
}) => (
    <Paper
        style={{padding: '12px 16px', marginBottom: 16}}
        sx={{display: 'flex', alignItems: 'center', gap: 3, flexWrap: 'wrap'}}
    >
        <TextField
            size="small"
            placeholder="Search by account name, account #, or parent account"
            value={searchText}
            onChange={(e) => onSearchTextChange(e.target.value)}
            sx={{minWidth: 320, flexGrow: 1, maxWidth: 480}}
            InputProps={{
                startAdornment: <InputAdornment position="start"><Search fontSize="small"/></InputAdornment>,
                endAdornment: searchText ? (
                    <InputAdornment position="end">
                        <IconButton size="small" aria-label="Clear search" onClick={() => onSearchTextChange('')}>
                            <Clear fontSize="small"/>
                        </IconButton>
                    </InputAdornment>
                ) : null,
            }}
        />
        <FormControl size="small" sx={{minWidth: 320}}>
            <InputLabel id="risk-tier-filter-label">Risk Score</InputLabel>
            <Select
                labelId="risk-tier-filter-label"
                label="Risk Score"
                multiple
                value={riskTiers}
                onChange={(e) => onRiskTiersChange(e.target.value)}
                renderValue={(selected) => (
                    (selected.length === 0 || selected.length === ALL_RISK_TIER_VALUES.length)
                        ? 'All'
                        : selected.map((v) => RISK_TIER_LABEL_BY_VALUE[v] || v).join(', ')
                )}
            >
                {RISK_TIER_FILTER_OPTIONS.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                        <Checkbox size="small" checked={riskTiers.includes(opt.value)}/>
                        <ListItemText primary={opt.label}/>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
        {buyingLessOnly && (
            <Chip
                size="small"
                label="Filtered: Buying Less"
                onDelete={onClearBuyingLessOnly}
                color="primary"
                variant="outlined"
            />
        )}
    </Paper>
);
